import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=68b9c1b8&scoped=true&"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js&"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=68b9c1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9c1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b9c1b8')) {
      api.createRecord('68b9c1b8', component.options)
    } else {
      api.reload('68b9c1b8', component.options)
    }
    module.hot.accept("./RootNodeConfig.vue?vue&type=template&id=68b9c1b8&scoped=true&", function () {
      api.rerender('68b9c1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/comon/process/config/RootNodeConfig.vue"
export default component.exports